import { importProvidersFrom } from '@angular/core';
import { FingerprintjsProAngularModule } from '@fingerprintjs/fingerprintjs-pro-angular';
import { environment } from '../../../environments/environment';

export function provideFingerprintjsPro() {
  return importProvidersFrom(
    FingerprintjsProAngularModule.forRoot({
      loadOptions: {
        apiKey: environment.fingerprintjs.apiKey,
        endpoint: 'https://fingerprintjs.firmfirst.com',
        scriptUrlPattern:
          'https://fingerprintjs.firmfirst.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
      },
    }),
  );
}
